{
    "components": {
        "buttons": {
            "default": {
                "add_to_cart": {
                    "label": "Aggiungi al carrello"
                },
                "back": {
                    "label": "Indietro"
                },
                "cancel": {
                    "label": "Annulla"
                },
                "close": {
                    "label": "Chiudi"
                },
                "confirm": {
                    "label": "Conferma"
                },
                "delete": {
                    "label": "Elimina"
                },
                "edit": {
                    "label": "Modifica"
                },
                "next": {
                    "label": "Avanti"
                },
                "previous": {
                    "label": "Precedente"
                },
                "proceed_configuration": {
                    "label": "Continua"
                },
                "save": {
                    "label": "Salva"
                },
                "start_ordering": {
                    "label": "Inizia a ordinare"
                },
                "upload_photo": {
                    "label": "Carica foto"
                }
            },
            "previous_page": {
                "label": "Pagina precedente"
            },
            "close": {
                "label": "Chiudi"
            }
        },
        "discount_blocks": {
            "code_copied": "Codice copiato!"
        },
        "dropdown": {
            "menu_button": {
                "label": "Menu"
            }
        },
        "footer": {
            "newsletter": {
                "title": "Non perderti mai più un'offerta",
                "subtitle": "Iscriviti alla nostra newsletter",
                "email_label": "Indirizzo e-mail",
                "submit_button": "Invia"
            }
        },
        "header": {
            "all_categories_line_1": "Vedi tutte le",
            "all_categories_line_2": "categorie",
            "search_aria_label": "Cerca",
            "search_close_aria_label": "Chiudi ricerca",
            "search_placeholder": "Cosa stai cercando?",
            "search_all_designs_title": "Tutti i design per ‘{query}’",
            "search_all_designs_label": "design",
            "search_suggestions_title": "Suggerimenti di ricerca",
            "search_products_title": "Prodotti",
            "search_no_results_title": "Nessun design per ‘{query}’",
            "search_no_results_hint": "Controlla l’ortografia o prova una parola più generica.",
            "search_scope_all_products": "Tutti i prodotti",
            "search_scope_products": "Prodotto…",
            "search_all_designs_title_scoped": "Tutti i design per ‘{query}’ in {group}",
            "search_scope_reset": "Cerca ‘{query}’ in tutti i prodotti",
            "search_popular_on_title": "Popolare su {name}",
            "search_categories_title": "Categorie"
        },
        "layouts": {
            "login_status": {
                "cart": {
                    "label": "Carrello"
                },
                "login": {
                    "label": "Accedi"
                },
                "welcome": {
                    "label": "Benvenuto,"
                },
                "welcome_back": {
                    "label": "Bentornato"
                }
            },
            "mobile_menu_button": {
                "label": "Menu"
            },
            "mobile_menu_drawer": {
                "back_to_categories": "Torna a tutte le categorie",
                "close": "Chiudi menu",
                "default_title": "Menu",
                "view_all": "Visualizza tutto {title}",
                "expand_submenu": "Espandi sottomenu"
            }
        },
        "select_menus": {
            "default": {
                "placeholder": "Seleziona opzione"
            }
        },
        "spinners": {
            "default": {
                "label": "Caricamento..."
            }
        },
        "header_slider": {
            "timer": {
                "days": "g",
                "hours": "h",
                "minutes": "m",
                "seconds": "s"
            }
        },
        "modals": {
            "register": {
                "has_account": "Hai già un account?",
                "general_error": "Registrazione non riuscita. Riprova."
            },
            "login": {
                "title": "Accedi"
            }
        },
        "wishlist": {
            "button": {
                "add_aria_label": "Aggiungi alla lista dei desideri",
                "remove_aria_label": "Rimuovi dalla lista dei desideri"
            },
            "header_button": {
                "aria_label": "Lista dei desideri"
            },
            "toast": {
                "removed": "Rimosso dalla tua lista dei desideri",
                "undo": "Annulla"
            },
            "guest_added": {
                "title": "Lista dei desideri",
                "success": "Aggiunto alla tua lista dei desideri",
                "login_prompt": "{login} o {register} per conservare la tua lista dei desideri su tutti i tuoi dispositivi e condividerla.",
                "login": "Accedi",
                "register": "crea un account",
                "continue_shopping": "Continua lo shopping",
                "view_wishlist": "Vedi la lista dei desideri"
            }
        },
        "related_products": {
            "title": "Scegli il tuo design",
            "show_all": "Vedi tutti",
            "show_less": "Mostra meno",
            "section_title": "Scopri di più da questa collezione"
        },
        "same_kind_products": {
            "title": "Anche questi ti piaceranno sicuramente"
        },
        "same_print_products": {
            "title": "Questa stampa su più prodotti"
        },
        "pdp_steps": {
            "step_label": "Passo {number}"
        },
        "pdp_review_videos": {
            "play_label": "Riproduci la recensione video di {name}"
        },
        "video": {
            "play_label": "Riproduci video"
        },
        "slider": {
            "go_to_item": "Vai all’elemento {index} di {total}"
        },
        "lightbox": {
            "counter": "{current} di {total}"
        },
        "share": {
            "copy": "Copia link",
            "copied": "Link copiato",
            "more": "Altro",
            "sms": "Messaggi",
            "email": "Email"
        }
    },
    "general": {
        "delivery_options": {
            "day_after_tomorrow": {
                "label": "Ordina oggi, consegnato <b>dopodomani</b>!"
            },
            "delivered_in_days": {
                "label": "Consegnato in <b>{days} giorni</b>"
            },
            "delivered_in_business_days": {
                "label": "Oggi ordinato, consegna in {days} giorno lavorativo! | Oggi ordinato, consegna in {days} giorni lavorativi!"
            },
            "today_delivery": {
                "label": "Ordina oggi, consegnato <b>oggi</b>!"
            },
            "tomorrow_delivery": {
                "label": "Ordina oggi, consegnato <b>domani</b>!"
            }
        },
        "password": {
            "confirmation": {
                "label": "Conferma password"
            },
            "confirmation_new": {
                "label": "Conferma nuova password"
            },
            "current": {
                "label": "Password attuale"
            },
            "label": "Password",
            "mismatch": "Le password non corrispondono, controlla nuovamente i campi.",
            "new": {
                "label": "Nuova password"
            },
            "requirements": "Usa 3 diversi tipi di caratteri. Caratteri possibili: lettere minuscole, lettere maiuscole, numeri e caratteri speciali."
        },
        "price_tables": {
            "entries": {
                "amount_label": "1 pezzo | {count} pezzi",
                "all_sizes": "Tutte le misure"
            },
            "title": {
                "amount": "Quantità",
                "size": "Dimensione"
            }
        },
        "prices": {
            "excl_discount": {
                "label": "Prezzo escl. sconto"
            },
            "for": {
                "label": "Per"
            },
            "from": {
                "label": "Da"
            },
            "starting_from": {
                "label": "A partire da"
            },
            "title": "Prezzi",
            "total": {
                "label": "Totale"
            }
        },
        "product_description": {
            "title": "Descrizione del prodotto"
        },
        "question_and_answers": {
            "no_data": {
                "primary_text": "Nessuna domanda e risposta trovata."
            },
            "title": "Domande e risposte",
            "subtitle": "Le domande più frequenti dei clienti."
        },
        "reviews": {
            "buyer": "Acquirente",
            "customer_images": "Immagini dei clienti",
            "view_more_images": "Vedi di più",
            "filter_all_stars": "Mostra tutto",
            "filter_label": "Filtro",
            "filter_stars": "1 stella | {count} stelle",
            "highest_rated_title": "Recensioni dei clienti",
            "no_reviews_title": "Ancora nessuna recensione scritta",
            "no_reviews_description": "C'è 1 valutazione da {rating} stelle. | Ci sono {votes} valutazioni con una media di {rating} stelle.",
            "image_alt": "Immagine della recensione",
            "no_results_for_filter": "Nessuna recensione per questo filtro.",
            "read_full_review": "Leggi la recensione completa",
            "review_amount": "{count} valutazione | {count} valutazioni",
            "review_count": "{votes} valutazioni di cui {reviewCount} scritte",
            "show_all_reviews": "Mostra tutte le {count} recensioni dei clienti",
            "show_less": "Mostra meno",
            "show_original": "Questa è una traduzione, mostra originale",
            "show_star_reviews": "Mostra recensioni {score} stelle",
            "show_translation": "Mostra traduzione",
            "title": "Recensioni dei clienti",
            "about": "Su:",
            "read_more": "Leggi di più",
            "show_all": "Mostra tutte le {count}",
            "votes_count": "1 valutazione | {count} valutazioni"
        },
        "shipping_options": {
            "title": "Opzioni di consegna"
        },
        "show_more_products": "Mostra più prodotti",
        "stock": {
            "available": "Disponibile immediatamente dal magazzino"
        },
        "checkout": {
            "title": "Cassa"
        },
        "filter_amount_products": "Filtra {count} prodotti",
        "pickup_points": {
            "pickup_location": {
                "confirmed": "Punto di ritiro selezionato!",
                "select": "Ritiro qui"
            }
        },
        "price_table": {
            "filters": {
                "show_less": "Mostra meno dimensioni",
                "show_more": "Mostra altre dimensioni"
            }
        },
        "show_less_collections": "Mostra meno collezioni",
        "show_more_collections": "Mostra altre collezioni",
        "show_more": "Mostra di più",
        "show_less": "Mostra meno",
        "product_details": "Informazioni sul prodotto"
    },
    "pages": {
        "cart_page": {
            "add_product": "Aggiungi un altro prodotto",
            "coupon_applied": "Codice sconto applicato.",
            "coupon_apply_failed": "Il codice sconto non ha potuto essere applicato.",
            "free_shipping_remaining": "Mancano {amount} per la {free}",
            "free_shipping_goal": "spedizione gratuita",
            "free_shipping_exception": "Esclusi i pacchi XXL",
            "no_items_proceed_shopping_link": "qui",
            "overview_title": "Panoramica",
            "pages_count": "{count} pagine",
            "quantity_update_failed": "La quantità non può essere aggiornata.",
            "remove_modal": {
                "cancel": "Annulla",
                "confirm": "Sei sicuro di voler rimuovere questo prodotto dal carrello?",
                "set_confirm": "Se rimuovi questo prodotto, lo sconto del set non si applicherà più agli altri prodotti. Sei sicuro di volerlo rimuovere?",
                "title": "Rimuovi prodotto",
                "yes": "Sì, elimina"
            },
            "cart_item": {
                "delete": "Rimuovi",
                "edit": "Modifica",
                "edit_failed": "Non è stato possibile aprire il prodotto per la modifica. Riprova.",
                "quantity": {
                    "label": "Quantità"
                },
                "set_count": "{count} prodotto | {count} prodotti",
                "show_details": "Mostra dettagli"
            },
            "messages": {
                "success": {
                    "deleted": "Il prodotto è stato rimosso dal carrello."
                }
            },
            "no_items": "Non ha prodotti nel carrello.",
            "overview": {
                "coupon_code": {
                    "button": {
                        "label": "Applica"
                    },
                    "cancel": "Annulla",
                    "input": {
                        "placeholder": "Inserisca il codice sconto"
                    },
                    "title": "Inserisca un codice sconto"
                },
                "coupon_code_display": "Codice sconto ({code})",
                "coupon_codes_display": "Codici coupon",
                "discount_display": "Sconto",
                "item_count": "1 articolo | {count} articoli",
                "prices": {
                    "discount": "Risparmio",
                    "grand_total": "Totale",
                    "shipping": "Spedizione",
                    "subtotal": "Subtotale",
                    "tax": "IVA",
                    "tax_included": "di cui IVA {amount}",
                    "total_incl_tax": "Subtotale (IVA incl.)"
                }
            },
            "proceed_to_checkout": "Procedi al pagamento",
            "title": "Carrello",
            "no_items_proceed_shopping": "Clicchi {link} per continuare gli acquisti.",
            "free_shipping": "Spedizione gratuita",
            "free_shipping_reached": "{free} per il tuo ordine",
            "checkout_hint": "Dopo: scegli indirizzo e momento di consegna"
        },
        "category": {
            "filters_title": "Filtra",
            "clear_all": "Cancella tutto",
            "selected_count": "{count} selezionati",
            "selected_filters": "Filtri selezionati",
            "hierarchy_all": "Tutto {label}",
            "close_filters": "Chiudi filtri",
            "no_filter_options_available": "Nessuna opzione di filtro disponibile",
            "no_image": "Nessuna immagine",
            "open_grid_view": "Apri vista griglia",
            "open_list_view": "Apri vista elenco",
            "open_two_column_view": "Apri vista a 2 colonne",
            "products": {
                "label": "prodotti",
                "prices": {
                    "recommended_price": "altro"
                }
            },
            "remove_filter": "Rimuovi filtro {filter}: {value}",
            "show_results": "Mostra risultati",
            "show_results_with_count": "Mostra {count} risultati",
            "clear_filters": "Rimuovi tutti i filtri",
            "filter": "Filtro",
            "show_less_filters": "Mostra meno",
            "show_more_filters": "Mostra altro",
            "faqs": {
                "title": "Domande frequenti"
            },
            "header": {
                "header_description": {
                    "show_more": "Mostra di più",
                    "show_less": "Mostra meno"
                }
            },
            "filter_explanation": "Maggiori informazioni su questo filtro"
        },
        "collection": {
            "delivery_options": {
                "pickup_point": "Punto di ritiro (scelta sostenibile)"
            }
        },
        "customers": {
            "dashboard": {
                "account_information": {
                    "form": {
                        "assistance_allowed_label": "Consenti assistenza remota durante gli acquisti",
                        "assistance_allowed_tooltip": "Questo consente al personale di vedere il tuo schermo ed eseguire azioni per tuo conto per assisterti meglio durante gli acquisti.",
                        "email_label": "Indirizzo e-mail",
                        "first_name_label": "Nome",
                        "last_name_label": "Cognome",
                        "legend": "Informazioni account",
                        "submit_button": "Salva"
                    },
                    "index": {
                        "intro": "I miei dati di contatto e le impostazioni dell'account.",
                        "title": "Informazioni account"
                    }
                },
                "address": {
                    "billing_title": "Indirizzo di fatturazione predefinito",
                    "description": "Indirizzo di fatturazione e spedizione predefinito attuale.",
                    "legend": "Rubrica degli indirizzi",
                    "manage_link": "Gestisci indirizzi",
                    "shipping_title": "Indirizzo di spedizione predefinito"
                },
                "addresses": {
                    "create": {
                        "intro": "Aggiungi un nuovo indirizzo alla rubrica degli indirizzi.",
                        "title": "Nuovo indirizzo"
                    },
                    "default_cards": {
                        "empty_state": "Nessun indirizzo predefinito ancora impostato."
                    },
                    "edit": {
                        "intro": "Modifica un indirizzo esistente dalla rubrica degli indirizzi.",
                        "title": "Modifica indirizzo"
                    },
                    "form": {
                        "address_legend": "Indirizzo",
                        "city_label": "Città",
                        "company_label": "Azienda",
                        "contact_legend": "Dati di contatto",
                        "countries": {
                            "AT": "Austria",
                            "BE": "Belgio",
                            "DE": "Germania",
                            "FR": "Francia",
                            "LU": "Lussemburgo",
                            "NL": "Paesi Bassi"
                        },
                        "country_label": "Paese",
                        "default_billing_label": "Usa come indirizzo di fatturazione predefinito",
                        "default_shipping_label": "Usa come indirizzo di spedizione predefinito",
                        "first_name_label": "Nome",
                        "last_name_label": "Cognome",
                        "postcode_label": "Codice postale",
                        "region_label": "Stato/Provincia",
                        "street1_label": "Indirizzo",
                        "street2_label": "Riga indirizzo 2",
                        "submit_create_button": "Aggiungi indirizzo",
                        "submit_edit_button": "Salva indirizzo",
                        "telephone_label": "Numero di telefono"
                    },
                    "index": {
                        "add_address_button": "Aggiungi indirizzo",
                        "billing_action_text": "Cambia indirizzo di fatturazione",
                        "billing_title": "Indirizzo di fatturazione predefinito",
                        "delete_modal_cancel_button": "Annulla",
                        "delete_modal_confirm_button": "Elimina",
                        "delete_modal_description": "Sei sicuro di voler eliminare questo indirizzo?",
                        "delete_modal_title": "Elimina indirizzo",
                        "intro": "I miei indirizzi e informazioni aggiuntive.",
                        "shipping_action_text": "Cambia indirizzo di spedizione",
                        "shipping_title": "Indirizzo di spedizione predefinito",
                        "title": "Rubrica degli indirizzi"
                    },
                    "list": {
                        "address_column": "Indirizzo",
                        "city_column": "Città",
                        "company_column": "Azienda",
                        "country_column": "Paese",
                        "delete_label": "Elimina",
                        "edit_title": "Modifica",
                        "empty_state": "Nessun altro indirizzo ancora impostato.",
                        "legend": "Altri indirizzi",
                        "name_column": "Nome"
                    }
                },
                "empty_address_state": "Non è stato ancora impostato nessun indirizzo.",
                "intro": "Benvenuto {firstName}! Di seguito trovi tutte le tue informazioni e gli ordini recenti.",
                "navigation": {
                    "account_information": "Informazioni account",
                    "address_book": "Rubrica degli indirizzi",
                    "dashboard": "Pannello",
                    "logout": "Disconnettiti",
                    "orders": "I miei ordini",
                    "projects": "I miei fotolibri",
                    "security": "Sicurezza",
                    "title": "Il mio account",
                    "wishlist": "Lista dei desideri"
                },
                "order_history": {
                    "detail": {
                        "header": {
                            "date_label": "Data"
                        },
                        "index": {
                            "back_button": "Torna al riepilogo ordini",
                            "intro": "Panoramica dettagliata di un ordine.",
                            "title": "Ordine #{number}"
                        },
                        "info": {
                            "billing_address_title": "Indirizzo di fatturazione",
                            "payment_method_title": "Metodo di pagamento",
                            "shipping_address_title": "Indirizzo di consegna",
                            "shipping_method_title": "Metodo di spedizione"
                        },
                        "items": {
                            "article_number_label": "Rif.",
                            "legend": "Articoli ordinati",
                            "price_column": "Prezzo",
                            "product_name_column": "Nome prodotto",
                            "quantity_column": "Quantità",
                            "subtotal_column": "Subtotale"
                        },
                        "totals": {
                            "discount": "Sconto",
                            "grand_total": "Totale (IVA incl.)",
                            "grand_total_excluding_tax": "Totale (IVA escl.)",
                            "shipping": "Spedizione e gestione",
                            "subtotal": "Subtotale",
                            "tax": "IVA"
                        }
                    },
                    "index": {
                        "intro": "Panoramica degli ordini effettuati.",
                        "legend": "I miei ordini",
                        "order_count": "{count} ordine | {count} ordini",
                        "title": "I miei ordini"
                    },
                    "table": {
                        "date_column": "Data",
                        "empty_state": "Non hai ancora effettuato ordini.",
                        "order_number_column": "N. ordine",
                        "status_column": "Stato",
                        "total_column": "Totale",
                        "tracking_column": "Tracciamento",
                        "view_label": "Vedi"
                    }
                },
                "orders": {
                    "date_column": "Data",
                    "empty_state": "Non hai ancora effettuato ordini.",
                    "legend": "Ordini recenti",
                    "order_number_column": "N. ordine",
                    "shipping_to_column": "Spedire a",
                    "status_column": "Stato",
                    "total_column": "Totale",
                    "view_all_link": "Vedi tutto",
                    "view_link": "Vedi"
                },
                "profile": {
                    "create": {
                        "intro": "Aggiungi un nuovo indirizzo alla rubrica degli indirizzi.",
                        "title": "Nuovo indirizzo"
                    },
                    "edit": {
                        "intro": "Modifica un indirizzo esistente dalla rubrica degli indirizzi.",
                        "title": "Modifica indirizzo"
                    },
                    "edit_link": "Modifica le informazioni del tuo account",
                    "form": {
                        "address_legend": "Indirizzo",
                        "city_label": "Città",
                        "company_label": "Azienda",
                        "contact_legend": "Dati di contatto",
                        "country_label": "Paese",
                        "default_billing_label": "Usa come indirizzo di fatturazione predefinito",
                        "default_shipping_label": "Usa come indirizzo di spedizione predefinito",
                        "first_name_label": "Nome",
                        "last_name_label": "Cognome",
                        "postcode_label": "Codice postale",
                        "region_label": "Stato/Provincia",
                        "street1_label": "Indirizzo",
                        "street2_label": "Riga indirizzo 2",
                        "submit_create_button": "Aggiungi indirizzo",
                        "submit_edit_button": "Salva indirizzo",
                        "telephone_label": "Numero di telefono"
                    },
                    "legend": "Dati di contatto",
                    "list": {
                        "address_column": "Indirizzo",
                        "city_column": "Città",
                        "company_column": "Azienda",
                        "country_column": "Paese",
                        "delete_label": "Elimina",
                        "edit_title": "Modifica",
                        "empty_state": "Nessun altro indirizzo ancora impostato.",
                        "legend": "Altri indirizzi",
                        "name_column": "Nome"
                    }
                },
                "projects": {
                    "index": {
                        "intro": "I miei progetti salvati e fotolibri.",
                        "legend": "I miei fotolibri",
                        "title": "I miei fotolibri"
                    },
                    "list": {
                        "actions_column": "Azioni",
                        "empty_state": "Non hai ancora salvato alcun fotolibro.",
                        "fallback_text": "Anteprima album fotografico",
                        "preview_alt": "Anteprima",
                        "preview_link": "Anteprima",
                        "product_column": "Prodotto",
                        "project_link": "Vai al progetto",
                        "updated_at_column": "Ultimo aggiornamento"
                    }
                },
                "security": {
                    "form": {
                        "legend": "Cambia password",
                        "submit": "Salva password"
                    },
                    "index": {
                        "intro": "Aggiorna qui la password del tuo account.",
                        "title": "Sicurezza"
                    }
                },
                "title": "Il mio account",
                "wishlist": {
                    "index": {
                        "empty_state": "La tua lista dei desideri è vuota.",
                        "intro": "Prodotti che hai salvato.",
                        "legend": "La mia lista dei desideri",
                        "title": "Lista dei desideri",
                        "guest_notice": "Salvato su questo dispositivo · {login} per vedere i tuoi articoli ovunque",
                        "guest_notice_login": "Accedi"
                    },
                    "share": {
                        "button": "Condividi",
                        "title": "Condividi la tua lista dei desideri con altri",
                        "description": "Chiunque abbia questo link può vedere la tua lista dei desideri."
                    },
                    "shared": {
                        "title": "Lista dei desideri condivisa",
                        "intro": "Questi prodotti sono stati condivisi con te."
                    }
                },
                "intro_no_name": "Benvenuto! Di seguito trovi tutte le tue informazioni e gli ordini recenti."
            },
            "login": {
                "index": {
                    "create_account": "Crea account",
                    "description": "Se hai un account, accedi con il tuo indirizzo e-mail.",
                    "email_label": "Indirizzo e-mail",
                    "email_placeholder": "nome{'@'}esempio.it",
                    "forgot_password": "Password dimenticata?",
                    "intro": "Accedi o crea un account per andare alla tua dashboard.",
                    "legend": "Accedi",
                    "new_customers_description": "La creazione di un account ha molti vantaggi: checkout più veloce, salva più indirizzi, tieni traccia degli ordini e altro ancora.",
                    "new_customers_legend": "Nuovi clienti",
                    "password_label": "Password",
                    "password_placeholder": "Inserisci la tua password",
                    "submit": "Accedi",
                    "title": "Accedi",
                    "sso_facebook": "Continua con Facebook",
                    "sso_google": "Continua con Google",
                    "sso_separator": "Oppure"
                }
            },
            "passwords": {
                "forgot": {
                    "index": {
                        "back_button": "Torna all’accesso",
                        "description": "Se esiste un account con l'indirizzo e-mail indicato, riceverai un'e-mail.",
                        "email_label": "Indirizzo e-mail",
                        "email_placeholder": "nome{'@'}esempio.it",
                        "intro": "Inserisci il tuo indirizzo e-mail di seguito per ricevere un link per la reimpostazione della password.",
                        "submit_button": "Invia",
                        "title": "Password dimenticata?"
                    }
                },
                "reset": {
                    "index": {
                        "intro": "Scegli una nuova password per il tuo account qui sotto.",
                        "submit": "Imposta una nuova password",
                        "title": "Imposta nuova password"
                    }
                }
            },
            "register": {
                "credentials": {
                    "email_label": "Indirizzo e-mail",
                    "legend": "Credenziali di accesso",
                    "privacy_link": "Informativa sulla privacy",
                    "privacy_prefix": "Accetto la"
                },
                "index": {
                    "back_button": "Torna all’accesso",
                    "intro": "Crea un nuovo account per gestire i tuoi ordini, indirizzi e progetti.",
                    "submit_button": "Crea account",
                    "title": "Crea un nuovo account"
                },
                "profile": {
                    "first_name_label": "Nome",
                    "last_name_label": "Cognome",
                    "legend": "Informazioni personali",
                    "subscribe_label": "Iscriviti alla newsletter"
                }
            }
        },
        "errors": {
            "back_to_home": "Torna alla home",
            "404": {
                "heading": "Pagina non trovata.",
                "description": "Non siamo riusciti a trovare la pagina che stai cercando. Il link potrebbe essere scaduto o la pagina è stata spostata."
            },
            "500": {
                "heading": "Qualcosa è andato storto.",
                "description": "Si è verificato un errore imprevisto da parte nostra. Riprova più tardi."
            },
            "403": {
                "heading": "Accesso negato.",
                "description": "Non hai il permesso di visualizzare questa pagina."
            },
            "503": {
                "heading": "Temporaneamente non disponibile.",
                "description": "Il sito è temporaneamente non disponibile. Riprova più tardi."
            },
            "generic": {
                "heading": "Si è verificato un errore.",
                "description": "Si è verificato un errore imprevisto. Riprova più tardi."
            }
        },
        "product_detail_page": {
            "share": {
                "label": "Condividi questa pagina",
                "title": "Condividi questo prodotto con altri"
            },
            "product_info": {
                "benefits": {
                    "title": "I vantaggi di {storeName}",
                    "payment_methods_label": "paga, tra gli altri, con"
                },
                "klarna": {
                    "loading": {
                        "label": "Klarna è in caricamento..."
                    }
                },
                "modals": {
                    "product_options_modal": {
                        "overview": {
                            "title": "Riepilogo"
                        },
                        "title": "Opzioni del prodotto"
                    }
                },
                "product_button": {
                    "add_to_cart": {
                        "error": "Si è verificato un errore durante l'aggiunta al carrello.",
                        "loading": {
                            "description": "Verrai reindirizzato automaticamente.",
                            "label": "Aggiunta al carrello..."
                        },
                        "set_error": "Si è verificato un errore durante l'aggiunta del set. Alcune parti potrebbero essere già nel carrello: controllalo prima di riprovare."
                    },
                    "book_login_modal": {
                        "continue_without_login": "Continua senza accedere",
                        "continue_without_login_warning": "Se continui senza accedere, le tue foto non verranno salvate. Non potrai modificare o completare il prodotto in seguito.",
                        "description": "Accedi per salvare i tuoi progressi e continuare il tuo progetto in seguito.",
                        "email_label": "Indirizzo e-mail",
                        "email_placeholder": "nome{'@'}esempio.it",
                        "forgot_password": "Password dimenticata?",
                        "general_error": "Accesso non riuscito. Controlla i tuoi dati e riprova.",
                        "no_account": "Non hai ancora un account?",
                        "password_label": "Password",
                        "password_placeholder": "Inserisci la tua password",
                        "separator": "Oppure",
                        "submit": "Accedi",
                        "title": "Accedi"
                    },
                    "new_project_modal": {
                        "description": "Assegna un titolo al tuo libro fotografico per ritrovarlo facilmente. Potrai sempre cambiarlo in seguito.",
                        "submit": "Inizia a creare",
                        "title": "Dai un nome al progetto",
                        "title_hint": "{count} / 150",
                        "title_label": "Titolo del progetto",
                        "title_placeholder": "Es. Vacanze {year}, Album di famiglia..."
                    },
                    "recent_projects_modal": {
                        "description": "Continua con un progetto fotolibro esistente o inizia un nuovo progetto.",
                        "empty_state": "Non hai ancora progetti fotolibro recenti.",
                        "error": "Si è verificato un errore durante il caricamento dei tuoi progetti.",
                        "loading": "Caricamento dei tuoi progetti recenti...",
                        "next_page": "Successiva",
                        "open_error": "Non è stato possibile aprire il progetto. Riprova.",
                        "open_project": "Apri progetto",
                        "opening": "Apertura...",
                        "pagination": "Pagina {page} di {total}",
                        "previous_page": "Precedente",
                        "retry": "Riprova",
                        "sheet_count": "{count} pagine",
                        "start_new_project": "Inizia un nuovo progetto",
                        "title": "Progetti recenti",
                        "updated_at": "Ultima modifica: {date}"
                    },
                    "start_ordering": {
                        "loading": {
                            "description": "Stiamo preparando il designer per te.",
                            "label": "Il tuo prodotto viene preparato..."
                        }
                    },
                    "start_over": {
                        "confirm_modal": {
                            "cancel": "Annulla",
                            "confirm": "Sì, ricomincia",
                            "description": "La tua foto e le impostazioni correnti verranno rimosse. L'operazione non può essere annullata.",
                            "title": "Sei sicuro di voler ricominciare?"
                        },
                        "label": "O ricominciare, scegli una nuova foto"
                    },
                    "upload": {
                        "errors": {
                            "file_too_large": "Questa foto è troppo grande. Carica un'immagine di massimo 100 MB.",
                            "generic": "Qualcosa è andato storto durante il caricamento. Riprova.",
                            "invalid_file_type": "Questo tipo di file non è supportato. Carica un'immagine JPG, PNG o WebP.",
                            "retry_cta": "Riprova",
                            "title": "Caricamento non riuscito"
                        },
                        "leave_modal": {
                            "cancel": "Resta qui",
                            "confirm": "Interrompi caricamento",
                            "description": "La tua foto è ancora in fase di caricamento. Se esci ora, perderai i progressi.",
                            "title": "Sei sicuro di voler uscire?"
                        },
                        "offline": {
                            "description": "Sei offline. Riprenderemo non appena tornerai online.",
                            "title": "Nessuna connessione"
                        },
                        "redirecting": {
                            "description": "Stai per essere reindirizzato.",
                            "label": "Caricamento completato!"
                        },
                        "uploading": {
                            "description": "Stai per essere reindirizzato automaticamente.",
                            "label": "La tua foto è in elaborazione..."
                        }
                    },
                    "update_cart": {
                        "loading": {
                            "description": "Verrai reindirizzato automaticamente al carrello.",
                            "label": "Il tuo prodotto viene aggiornato."
                        }
                    },
                    "force_size_selection_message": "Seleziona prima una dimensione per continuare.",
                    "force_size_selection_tooltip": "Devi ancora selezionare una dimensione"
                },
                "product_filters": {
                    "choose_option": "Scegli un'opzione",
                    "make_your_choice": "Fai la tua scelta"
                },
                "product_set": {
                    "available_sizes_label": "Scegli i tuoi formati",
                    "discount_label": "Sconto set",
                    "position_label": "Immagine {number}",
                    "save_label": "Salva",
                    "standard_sizes_note": "Le immagini si basano su formati standard"
                },
                "switch_options": {
                    "with_name": "Con nome",
                    "without_name": "Senza nome"
                }
            },
            "user_text": {
                "error": {
                    "empty": "Nessun testo inserito"
                },
                "label": "Testo personale",
                "placeholder": "Inserisci il tuo testo..."
            },
            "price": {
                "from_abbreviation": "da",
                "instead_of": "invece di"
            },
            "after_upload_text": "Poi: scelga il formato e consulti i prezzi.",
            "timer": {
                "label": "{days} giorni e {hours}:{minutes}:{seconds}",
                "last_day_label": "Mancano solo {hours} ore e {minutes}:{seconds}",
                "one_day_label": "{days} giorno e {hours}:{minutes}:{seconds}"
            },
            "ai_upload": {
                "history": {
                    "loading_previous": "Caricamento della tua versione precedente",
                    "loading_latest": "Caricamento della tua versione più recente"
                },
                "auth": {
                    "email": {
                        "continue": "Continua",
                        "context": "Inserisci il tuo indirizzo e-mail per caricare la tua foto e generarla con l'IA.",
                        "error": "Qualcosa è andato storto. Riprova.",
                        "placeholder": "Il tuo indirizzo e-mail",
                        "title": "Continua"
                    },
                    "login": {
                        "context": "Esiste già un account per {email}. Accedi per continuare.",
                        "forgot_password": "Password dimenticata?",
                        "general_error": "Accesso non riuscito. Controlla i tuoi dati e riprova.",
                        "password_placeholder": "Inserisci la tua password",
                        "submit": "Accedi",
                        "title": "Accedi"
                    },
                    "otp": {
                        "general_error": "Qualcosa è andato storto. Riprova.",
                        "intro": "Ti abbiamo inviato un codice di verifica a {email}.",
                        "resend": "Non hai ricevuto il codice? Invia di nuovo",
                        "resend_sent": "Ti abbiamo inviato un nuovo codice.",
                        "submit": "Conferma e scegli la foto",
                        "title": "Conferma la tua email",
                        "submit_continue": "Conferma"
                    },
                    "success": {
                        "title": "Accesso effettuato!",
                        "cta": "Scegli la tua foto"
                    }
                },
                "ai_generated_badge": "Generato dall'IA",
                "view_full_screen": "Guarda la foto a schermo intero",
                "button": {
                    "label": "Inizia il tuo ordine",
                    "choose_photo": "Scegli la tua foto",
                    "try_again": "Riprova",
                    "offline": "Sei offline. Il caricamento riprenderà automaticamente non appena la connessione sarà ripristinata.",
                    "slow_connection": "Hai una connessione lenta. Il caricamento potrebbe richiedere un po' più di tempo.",
                    "add_text": "Aggiungi nome/testo",
                    "edit_text": "Modifica nome/testo",
                    "errors": {
                        "invalid_file_type": "Questo tipo di file non è supportato. Carica una foto in formato JPG, PNG o WEBP.",
                        "file_too_small": "Questo file è troppo piccolo. Scegli un'altra foto.",
                        "file_too_large": "Questo file è troppo grande. Carica una foto di massimo 100 MB."
                    }
                },
                "progress": {
                    "retry": "Riprova",
                    "retry_different_photo": "Carica un'altra foto",
                    "beauty_shots_failed": "Purtroppo non siamo riusciti a creare le anteprime del tuo prodotto. Per favore riprova.",
                    "overtime": "Ci vuole un po’ più del previsto. Stiamo ancora lavorando, attendi ancora un momento.",
                    "shot_pending": "Questa foto del prodotto è ancora in lavorazione. Le altre sono già pronte.",
                    "creating_previews": "Stiamo ora creando le anteprime del tuo prodotto...",
                    "title": "Il tuo ritratto è in fase di creazione",
                    "subtitle": "In media 60-90 secondi. Grazie per la pazienza.",
                    "baking_title": "Stiamo creando nuove immagini del prodotto per te",
                    "bake_progress_title": "Caricamento delle nuove immagini del prodotto",
                    "bake_progress_subtitle": "Nuove immagini del prodotto vengono create in base al tuo nome.",
                    "preparing_photo_error": "Non siamo riusciti a preparare la tua foto prodotto. Per favore riprova.",
                    "preparing_photo_and_cart_title": "Stiamo aggiungendo il tuo prodotto al carrello",
                    "preparing_photo_and_cart_description": "Nel frattempo, completiamo la tua foto prodotto personalizzata.",
                    "beauty_shots_count": "{completed} di {total}",
                    "steps": {
                        "analyzing": "Analisi della foto",
                        "recognizing": "Riconoscimento del volto",
                        "styling": "Applicazione dello stile",
                        "finalizing": "Finalizzazione del design",
                        "creating_images": "Creazione delle immagini",
                        "uploading": "Elaborazione della foto",
                        "generating": "Creazione dell'immagine",
                        "processing": "Rifinitura del ritratto",
                        "processing_plural": "Rifinitura dei ritratti",
                        "previews": "Creazione delle immagini prodotto",
                        "preview_single": "Creazione dell'immagine prodotto",
                        "preview_plural": "Creazione delle immagini prodotto",
                        "uploading_busy": "Sta richiedendo un po' più di tempo del previsto...",
                        "analyzing_busy": "Analisi in corso...",
                        "generating_busy": "Creazione della tua immagine...",
                        "generating_busy_plural": "Creazione delle tue immagini...",
                        "processing_busy": "Ultimi ritocchi...",
                        "previews_busy": "Le immagini prodotto sono in fase di creazione, ancora un momento...",
                        "baking_text": "Elaborazione del testo...",
                        "baking_style": "Applicazione di testo e stile",
                        "baking_text_subtitle": "Il tuo testo viene applicato al ritratto.",
                        "baking_photo": "Aggiornamento immagine prodotto",
                        "addition_activating": "Caricamento stile {label}",
                        "addition_transforming": "Trasformazione del ritratto",
                        "addition_transforming_subtitle": "Trasformiamo il tuo ritratto",
                        "addition_generating": "Generazione di {label}",
                        "addition_finalizing": "Completamento dei dettagli",
                        "uploading_subtitle": "Prepariamo la tua foto per l'IA",
                        "analyzing_subtitle": "Guardiamo cosa c'è nella tua foto",
                        "generating_subtitle": "L'IA sta creando la tua immagine",
                        "generating_subtitle_plural": "L'IA sta creando le tue immagini",
                        "processing_subtitle": "Aggiungiamo gli ultimi ritocchi",
                        "addition_activating_subtitle": "Carichiamo lo stile scelto",
                        "uploading_done": "Foto elaborata",
                        "analyzing_done": "Foto analizzata",
                        "generating_done": "Immagine creata",
                        "generating_done_plural": "Immagini create",
                        "processing_done": "Dettagli completati",
                        "addition_activating_done": "Stile caricato",
                        "addition_transforming_done": "Anteprima pronta"
                    },
                    "image_failed": "Non è stato possibile creare questa immagine prodotto."
                },
                "regenerate": {
                    "title": "Genera di nuovo",
                    "feedback_placeholder": "\"Più fedele\" o \"Colori più vivaci\"",
                    "with_feedback": "Con feedback",
                    "error_generic": "Qualcosa è andato storto. Riprova.",
                    "threshold_exceeded": "Il limite giornaliero di generazione di foto con IA è stato raggiunto. Riprova domani.",
                    "style_additions_generate": "Genera con {label}",
                    "style_additions_cost_notice": "Questo usa 1 credito IA",
                    "style_additions_title": "Scegli un'aggiunta"
                },
                "crop": {
                    "panel_title": "Seleziona il tuo viso",
                    "panel_description": "Usa il riquadro di selezione per inquadrare il tuo viso. Otterrai il miglior risultato.",
                    "image_load_error": "Non siamo riusciti a caricare la tua foto. Prova con un'altra immagine.",
                    "zoom_in": "Ingrandisci",
                    "zoom_out": "Riduci",
                    "validating": "Verifica foto…",
                    "error_title": "Non ha funzionato"
                },
                "validation": {
                    "retry": "Scegli un'altra foto",
                    "cancel": "Annulla",
                    "no_face": {
                        "title": "Volto non riconosciuto",
                        "description": "Non abbiamo riconosciuto un viso nitido nella tua selezione. Sposta la selezione sul viso oppure carica un’altra foto.",
                        "tip_1": "Guarda direttamente nell'obiettivo.",
                        "tip_2": "Assicurati di avere una buona illuminazione — evita la controluce.",
                        "tip_3": "Rimuovi occhiali da sole, maschere o cappelli."
                    },
                    "no_pet": {
                        "title": "Nessun animale domestico rilevato",
                        "description": "Non siamo riusciti a rilevare un animale domestico nella tua foto. Carica una foto in cui il tuo animale domestico sia chiaramente visibile."
                    },
                    "mismatch": {
                        "title": "Nessuna persona rilevata",
                        "description": "Non abbiamo riconosciuto nessuna persona nella tua selezione. Sposta la selezione sul viso oppure carica un’altra foto.",
                        "tip_1": "Sposta la selezione in modo che il viso rientri nel riquadro.",
                        "tip_2": "Oppure carica una foto in cui la persona sia ben visibile."
                    },
                    "unsafe": {
                        "title": "Foto non accettata",
                        "description": "La tua foto non rispetta le nostre linee guida. Carica un'altra foto.",
                        "tip_1": "Usa una foto ritratto neutra e appropriata."
                    },
                    "unavailable": {
                        "title": "Verifica foto non disponibile",
                        "description": "La verifica foto è temporaneamente non disponibile. La tua foto è stata inviata così com'è.",
                        "tip_1": "Riprova più tardi se riscontri problemi."
                    }
                },
                "daily_limit_reached": "La generazione di foto con IA è temporaneamente non disponibile. Riprova domani.",
                "user_daily_limit_reached": "Hai raggiunto il tuo limite di generazione AI. Riprova tra 1 ora. | Hai raggiunto il tuo limite di generazione AI. Riprova tra {count} ore.",
                "related_styles": {
                    "title": "Stili IA"
                },
                "view_previous_generations": "Visualizza le generazioni precedenti",
                "transfer": {
                    "title": "Riutilizza la tua foto precedente",
                    "dismiss": "Usa un'altra foto",
                    "generate": "Genera ora",
                    "photo_label": "La tua foto",
                    "change": "Cambia foto"
                },
                "beauty_shots_generating": "{count} foto prodotto ancora in generazione... | {count} foto prodotto ancora in generazione...",
                "personalization": {
                    "alignment_label": "Allineamento",
                    "weight_label": "Spessore",
                    "reset_text": "Reimposta il testo",
                    "remove_text": "Rimuovi il testo",
                    "remove_all_text": "Ricomincia",
                    "weight_300": "Sottile",
                    "weight_400": "Normale",
                    "weight_500": "Medio",
                    "weight_600": "Semigrasso",
                    "weight_700": "Grassetto",
                    "weight_800": "Extra grassetto",
                    "weight_900": "Nero",
                    "uncommitted_modal_title": "Testo non ancora generato",
                    "uncommitted_modal_body": "Hai aggiunto del testo, ma non è ancora stato generato sulla foto.",
                    "uncommitted_add_without_text": "Ordina senza testo",
                    "uncommitted_generate": "Genera e verifica",
                    "uncommitted_cancel": "Continua a personalizzare",
                    "uncommitted_generate_and_add": "Genera e continua",
                    "uncommitted_next_product_options": "Poi sceglierai le opzioni del prodotto.",
                    "uncommitted_next_redirect_to_cart": "Poi verrai reindirizzato automaticamente al carrello.",
                    "active_banner": "Altre foto bloccate",
                    "active_banner_tooltip": "Sei in modalità personalizzazione. Riduci la personalizzazione per rivedere le altre foto oppure genera un'anteprima.",
                    "remove": "Rimuovi testo",
                    "drag_hint": "Trascina per spostare",
                    "update_preview": "Salva e anteprima",
                    "add_text": "Aggiungi testo",
                    "generating": "Generazione in corso...",
                    "committed_hint": "Rimuovi un testo per tornare all'anteprima originale.",
                    "background_padding_label": "Spaziatura",
                    "color_label": "Colore del testo",
                    "font_label": "Carattere",
                    "mode_text": "Testo",
                    "preview_mode": "Modalità anteprima – non ancora generata",
                    "size_label": "Dimensione",
                    "text_placeholder": "Il tuo testo qui",
                    "title": "Aggiungi testo",
                    "title_update": "Aggiorna personalizzazione",
                    "field_label": "Nome/testo",
                    "cta_add": "Aggiungi",
                    "cta_edit": "Modifica",
                    "edit_baked_text": "Modifica il testo",
                    "edit_baked_notice": "Il tuo testo fa ora parte dell’immagine. Se lo modifichi, rifacciamo le foto con il nuovo testo.",
                    "view_photos": "Vedi tutte le foto",
                    "mobile_save": "Salva",
                    "text_done": "Salva il testo"
                },
                "cycle_limit_go_back": "← Vedi i risultati precedenti",
                "cycle_limit_reached_with_previous_title": "Hai esaurito tutti i tuoi tentativi",
                "user_limit_reached_unknown_wait": "Hai raggiunto il tuo limite di generazione AI. Riprova più tardi.",
                "status": {
                    "loading": {
                        "label": "La tua foto è in caricamento",
                        "description": "Poi ti porteremo automaticamente al passaggio successivo."
                    },
                    "offline": {
                        "title": "Nessuna connessione",
                        "description": "Sei offline. Riprenderemo non appena tornerai online."
                    },
                    "errors": {
                        "title": "Caricamento non riuscito",
                        "generic": "Qualcosa è andato storto durante il caricamento. Riprova.",
                        "retry_cta": "Riprova"
                    }
                }
            }
        },
        "product_options": {
            "preview_alt": "Anteprima",
            "saved_price": "Risparmi {amount}",
            "title": "Riepilogo del tuo prodotto",
            "preview_loading": "Caricamento anteprima...",
            "update_cart": "Aggiorna carrello"
        },
        "tools": {
            "add_to_cart_error": {
                "description": "Non siamo riusciti ad aggiungere il prodotto al carrello. Non preoccuparti — la tua configurazione è salvata.",
                "retry": "Riprova",
                "title": "Qualcosa è andato storto"
            },
            "ai": {
                "crop": {
                    "title": "Ritaglia",
                    "sidebar": "Strumenti di ritaglio"
                },
                "select": {
                    "title": "Scegli",
                    "heading": "Scegli la tua preferita",
                    "description": "Scegli la versione che preferisci.",
                    "candidate_label": "Versione {number}",
                    "name_placeholder": "Il tuo nome",
                    "candidate_pending": "Questa versione è ancora in creazione…",
                    "candidate_failed": "Non è stato possibile creare questa versione.",
                    "candidate_retry": "Riprova",
                    "candidate_selected": "Selezionata",
                    "select_candidate": "Scegli la versione {number}",
                    "view_larger": "Visualizza la versione {number} ingrandita",
                    "choose_this": "Scegli questa",
                    "show_all": "Mostra tutte le mie immagini",
                    "limit_reached": "Hai raggiunto il tuo limite di generazione. Scegli tra le immagini che hai già.",
                    "regenerate_question": "Non ti convincono?",
                    "regenerate": "Crea due nuove",
                    "regenerating": "Generazione di altre due immagini…",
                    "regenerate_error": "Non è stato possibile generare altre immagini. Riprova più tardi.",
                    "save_error": "Non è stato possibile salvare la tua scelta. Riprova."
                },
                "configurator": {
                    "title": "Personalizza",
                    "sidebar": "Testo",
                    "panel_title": "Aggiungi il tuo testo",
                    "name_required_hint": "Inserisci il tuo nome per continuare.",
                    "view_preview_button": "Vedi l'anteprima",
                    "preparing": {
                        "loading": {
                            "label": "Stiamo creando la tua immagine prodotto",
                            "description": "Un momento…"
                        }
                    }
                },
                "preview": {
                    "title": "Anteprima",
                    "shot_pending": "Questa immagine è ancora in creazione…",
                    "shot_failed": "Non è stato possibile creare questa immagine.",
                    "retry_shot": "Riprova",
                    "go_to_shot": "Vai all'immagine {number}",
                    "previous_shot": "Immagine precedente",
                    "next_shot": "Immagine successiva",
                    "view_larger": "Visualizza l'immagine {number} più grande",
                    "filling": "Creazione immagini"
                }
            },
            "mediaclip": {
                "configurator": {
                    "choose_size": {
                        "label": "Scegli la tua misura"
                    },
                    "custom_size": {
                        "label": "Scegli una dimensione personalizzata"
                    },
                    "title": "Configuratore"
                }
            },
            "product_options": {
                "title": "Opzioni prodotto"
            }
        },
        "success_page": {
            "banner": {
                "title": "Ordinato!",
                "sub_title": "Grazie per il tuo ordine. Iniziamo subito."
            },
            "title": "Cosa succede ora?",
            "steps": {
                "order_confirmation": {
                    "title": "Conferma dell'ordine",
                    "description": "Ti invieremo una conferma dell'ordine (<strong>#{orderNumber}</strong>) al tuo indirizzo e-mail. Trova tutti i tuoi ordini nel tuo account.",
                    "description_fallback": "Ti invieremo una conferma dell'ordine al tuo indirizzo e-mail. Trova tutti i tuoi ordini nel tuo account.",
                    "summary": {
                        "total_paid": "Totale pagato (IVA incl.)",
                        "total_in_email": "Troverai l'importo pagato nella conferma dell'ordine.",
                        "show": "Visualizza il tuo ordine",
                        "hide": "Nascondi il tuo ordine",
                        "discount": "Sconto",
                        "discount_code": "Codice sconto {code}",
                        "shipping": "Spese di spedizione",
                        "free": "Gratis",
                        "payment_fee": "Commissione di pagamento",
                        "other": "Altro",
                        "total": "Totale"
                    }
                },
                "shipping_confirmation": {
                    "title": "Conferma di spedizione",
                    "description": "Riceverai un'e-mail quando i tuoi prodotti saranno imballati e consegnati al corriere.",
                    "delivery_date": "Consegna prevista il"
                },
                "delivery_address": {
                    "title": "Indirizzo di consegna",
                    "description": "Il(i) tuo(i) articolo(i) verrà consegnato a",
                    "info": "Non sei in casa? Il pacco verrà lasciato dal vicino o in un punto di ritiro."
                },
                "questions": {
                    "title": "Domande?",
                    "description": "Siamo felici di aiutarti! Dai un'occhiata al nostro",
                    "customer_service_link": "pagina del servizio clienti",
                    "show_the_wow": {
                        "title": "Mostra il WOW!",
                        "description": "Mostra ai tuoi amici cosa ti sei regalato!",
                        "instagram_label": "Instagram",
                        "facebook_label": "Facebook"
                    },
                    "news_letter": {
                        "label": "Esclusivo",
                        "title": "Diventare membro WOW?",
                        "usp_1": "10% di sconto sul tuo prossimo ordine",
                        "usp_2": "Scopri nuovi design e prodotti prima di tutti",
                        "usp_3": "Codici sconto e promozioni esclusivi",
                        "button": "Diventa membro"
                    }
                }
            },
            "page_title": "Ordine effettuato!"
        },
        "checkout_page": {
            "form": {
                "delivery": {
                    "choose_pickup_location": "Scegli il tuo punto di ritiro",
                    "day_after_tomorrow_delivery": "Ordina oggi, <b>dopodomani</b> a casa tua!",
                    "deliver_at_pickup_location": "Seleziona un punto di ritiro",
                    "latest_delivery": "Il tuo pacco ti verrà consegnato a casa al più tardi il",
                    "no_address": "Inserisci il tuo indirizzo di consegna per visualizzare i metodi di spedizione disponibili.",
                    "no_pickup_locations": "Nessun punto di ritiro trovato",
                    "opening_times": {
                        "label": "Orari di apertura"
                    },
                    "selected_pickup_location": "Punto di ritiro selezionato:",
                    "show_other_pickup_locations": "Mostra altri punti di ritiro",
                    "tabs": {
                        "delivery": "Consegna",
                        "pickup": "Punto di ritiro"
                    },
                    "tomorrow_delivery": "Ordina oggi, <b>domani</b> a casa tua!",
                    "available_from": "Disponibile dal",
                    "error": "Si è verificato un errore durante il caricamento delle opzioni di consegna.",
                    "postal_code_search": {
                        "button": "Cerca",
                        "label": "CAP",
                        "placeholder": "Inserisci il CAP..."
                    },
                    "show_on_map": "Mostra sulla mappa"
                },
                "payment": {
                    "no_address": "Inserisci il tuo indirizzo di consegna per visualizzare i metodi di pagamento disponibili.",
                    "no_payment_required": "Nessun pagamento richiesto.",
                    "no_payment_required_subtitle": "Il tuo ordine è completamente coperto dal tuo codice sconto."
                }
            },
            "free": "Gratuito",
            "messages": {
                "errors": {
                    "billing_address_missing": "Il tuo indirizzo di fatturazione è incompleto. Controlla l'indirizzo e riprova.",
                    "placing_order_failed": "Al momento non è possibile effettuare l'ordine.",
                    "shipping_address_missing": "Il tuo indirizzo di spedizione è incompleto. Controlla l'indirizzo e riprova."
                }
            },
            "overview": {
                "place_order_button": {
                    "label": "Effettuare l'ordine"
                },
                "prices": {
                    "discount": "Sconto",
                    "shipping_costs": "Costi di spedizione",
                    "shipping_surcharge": "Supplemento",
                    "payment_fee": "Costi di pagamento",
                    "subtotal": "Subtotale",
                    "total": "Totale",
                    "you_save": "Risparmi",
                    "coupon_code": "Codice sconto",
                    "incl_vat": "di cui IVA {amount}",
                    "promotion_discount": "Sconto promozionale"
                },
                "quote_items": {
                    "count": "1 articolo | {count} articoli",
                    "quantity": "Quantità: {quantity}"
                },
                "title": "Panoramica"
            },
            "payment": {
                "most_popular": "Più scelto"
            }
        },
        "configurator": {
            "sizes": {
                "most_chosen": "Più scelto"
            }
        },
        "search": {
            "title": "Risultati di ricerca",
            "title_with_query": "Risultati di ricerca per ‘{query}’",
            "products_title": "Prodotti",
            "heading_all": "Tutti i design",
            "heading_with_query": "Risultati di ricerca per ‘{query}’",
            "heading_no_results": "Nessun risultato per ‘{query}’",
            "subtitle_no_results": "Controlla l'ortografia o prova un termine più generico.",
            "browse_by_product_title": "Sfoglia per prodotto"
        }
    },
    "slices": {
        "algolia_slider": {
            "price": {
                "else": "altrimenti",
                "from": "da"
            }
        },
        "plp_before_after": {
            "before": "Prima",
            "after": "Dopo"
        },
        "plp_customer_images": {
            "image_alt": "Foto del cliente"
        },
        "pdp_before_after": {
            "before": "Prima",
            "after": "Dopo"
        },
        "contact_form_business": {
            "gift_timing_placeholder": "Quando vuoi regalare le valigie?*",
            "referral_placeholder": "Come ci hai conosciuto?*",
            "no_options": "Nessuna opzione disponibile",
            "selected_file": "File selezionato:",
            "required_fields": "Compila tutti i campi obbligatori.",
            "submit_error": "Si è verificato un errore durante l'invio del modulo. Riprova.",
            "invalid_file_type": "Tipo di file non valido. Sono consentiti solo JPEG, PNG, GIF, BMP, WEBP o SVG."
        },
        "banner_slider": {
            "excellent": "Eccellente"
        }
    },
    "tools": {
        "mediaclip": {
            "configurator": {
                "designer": {
                    "loading": "Stiamo preparando il configuratore."
                },
                "footer": {
                    "buttons": {
                        "cancel": {
                            "label": "Annulla"
                        },
                        "change_size": {
                            "label": "Cambia formato ({size})"
                        },
                        "choose_size": {
                            "label": "Scegli la tua misura"
                        },
                        "to_photo": {
                            "label": "Alla foto {number}"
                        }
                    }
                },
                "hexagon_photos_required_modal": {
                    "title": "Foto mancanti",
                    "description": "Le foto {list} non sono ancora complete. Tocca una cornice vuota, carica la tua foto e riprova.",
                    "letter_collage_description": "Non tutte le cornici hanno ancora una foto. Tocca una cornice vuota, carica la tua foto e riprova.",
                    "close": "Capito"
                },
                "connection_lost_modal": {
                    "title": "Connessione persa",
                    "description": "Al momento non riusciamo a raggiungere il tuo progetto. Controlla la tua connessione internet e ricarica la pagina; il tuo progetto viene salvato automaticamente.",
                    "reload": "Ricarica la pagina"
                },
                "project_title": {
                    "error": "Salvataggio non riuscito",
                    "label": "Titolo del progetto",
                    "placeholder": "Inserisci un titolo...",
                    "saved": "Salvato",
                    "saving": "Salvataggio..."
                }
            }
        },
        "landscape_popup": {
            "text": "Questa pagina funziona meglio ruotando lo schermo. Ruoti lo schermo per continuare con l'ordine."
        }
    },
    "checkout": {
        "billing_address": {
            "title": "Indirizzo di fatturazione"
        },
        "delivery": {
            "preferences": {
                "label": "Quale consegna preferisci?",
                "express": {
                    "description": "Ordina oggi, consegna dopodomani!",
                    "label": "Consegna espressa"
                },
                "regular": {
                    "label": "Consegna standard"
                }
            },
            "title": "Consegna",
            "delivery_date_info": "Il tuo ordine sarà consegnato al più tardi il ",
            "info": "Inserisci i tuoi dati di spedizione per vedere le opzioni di consegna disponibili"
        },
        "form": {
            "address_finder": {
                "invalid_address": "L'indirizzo inserito non è stato trovato. Controlla i dati e riprova.",
                "label": "Ricerca indirizzo",
                "placeholder": "Inizia a digitare per cercare il tuo indirizzo",
                "address_filled": "Il tuo indirizzo è stato compilato.",
                "select_address": "Seleziona il tuo indirizzo dall'elenco."
            },
            "city": {
                "label": "Città",
                "placeholder": "Città",
                "invalid_characters": "Usa solo lettere, spazi, trattini (-) e apostrofi ('), fino a 100 caratteri."
            },
            "company": {
                "label": "Nome dell'azienda",
                "placeholder": "Nome dell'azienda"
            },
            "country": {
                "label": "Paese"
            },
            "email": {
                "label": "Indirizzo e-mail",
                "placeholder": "Indirizzo e-mail",
                "label_track_trace": "Indirizzo e-mail per il tracciamento della spedizione"
            },
            "first_name": {
                "label": "Nome",
                "placeholder": "Nome"
            },
            "house_number": {
                "label": "Numero civico",
                "placeholder": "es. 1"
            },
            "house_number_suffix": {
                "label": "Interno",
                "placeholder": "es. A"
            },
            "order_type": {
                "corporate": {
                    "label": "Azienda"
                },
                "private": {
                    "label": "Privato"
                },
                "title": "Tipo di ordine"
            },
            "phone_number": {
                "label": "Numero di telefono",
                "placeholder": "Numero di telefono",
                "invalid_characters": "Usa solo cifre, spazi e + - ( ), fino a 20 caratteri."
            },
            "same_address": {
                "label": "L'indirizzo di fatturazione e quello di spedizione coincidono"
            },
            "street_name": {
                "label": "Via",
                "placeholder": "Via"
            },
            "surname": {
                "label": "Cognome",
                "placeholder": "Cognome"
            },
            "vat_number": {
                "label": "Partita IVA",
                "placeholder": "Partita IVA"
            },
            "zipcode": {
                "label": "CAP",
                "placeholder_example": "es. {example}",
                "invalid": "Inserisci un CAP valido, es. {example}."
            },
            "save_in_address_book": {
                "label": "Salva nella rubrica degli indirizzi"
            },
            "newsletter_subscribe": {
                "label": "Tienimi aggiornato/a su notizie, ispirazioni e offerte esclusive via e-mail"
            },
            "account_type": {
                "title": "Account",
                "guest": {
                    "label": "Continua come ospite"
                },
                "create": {
                    "label": "Crea account"
                },
                "email_taken": "Esiste già un account con questo indirizzo e-mail.",
                "login_link": "Accedi",
                "password_required": "Inserisci due volte la stessa password per creare il tuo account.",
                "privacy_required": "Devi accettare l'informativa sulla privacy per creare il tuo account."
            }
        },
        "payment": {
            "title": "Pagamento",
            "ideal_wero": {
                "description": "iDEAL {'|'} Wero"
            },
            "paypal": {
                "description": "Paypal"
            }
        },
        "shipping_address": {
            "title": "Indirizzo di spedizione"
        },
        "customer_addresses": {
            "add_new": "Aggiungi nuovo indirizzo",
            "create_modal_title": "Nuovo indirizzo",
            "edit_modal_title": "Modifica indirizzo",
            "delete_modal_title": "Elimina indirizzo"
        },
        "address_book": {
            "add_new": "Aggiungi nuovo indirizzo",
            "default_billing": "Indirizzo di fatturazione predefinito",
            "default_shipping": "Indirizzo di spedizione predefinito",
            "create_modal": {
                "title_shipping": "Nuovo indirizzo di spedizione",
                "title_billing": "Nuovo indirizzo di fatturazione",
                "confirm": "Salva",
                "cancel": "Annulla"
            },
            "edit_modal": {
                "title": "Modifica indirizzo",
                "confirm": "Salva",
                "cancel": "Annulla"
            },
            "delete_modal": {
                "title": "Elimina indirizzo",
                "confirm": "Elimina",
                "cancel": "Annulla",
                "description": "Sei sicuro di voler eliminare questo indirizzo? Questa azione non può essere annullata."
            },
            "save_failed": "Salvataggio fallito. Per favore riprova.",
            "delete_failed": "Eliminazione fallita. Per favore riprova.",
            "order_only": "Solo per questo ordine"
        }
    }
}
